import type { SVGProps } from 'react';

/**
 * "Backtesting AI" rail icon — the four-point sparkle from Figma (2026-07-25).
 *
 * Deliberately stroked with `currentColor`, not the gradient baked into the Figma export: the
 * sidebar dims inactive icons (`text-text-muted`) and overrides the ACTIVE one to
 * `stroke: url(#nav-brand-grad)`. Hard-coding the gradient here would light the icon permanently and
 * destroy the active-item affordance — the exported SVG simply *was* the active state. The gradient
 * the sidebar applies is the same #009AC8 → #1BB980 brand ramp, so the active look is unchanged.
 *
 * Shaped like a `lucide-react` icon (props pass through, sized by `className`) so it drops straight
 * into `featureManifest.navIcon`. Like lucide, the stroke is set on the `<svg>` and the path INHERITS it
 * (2026-10-20 bug: with `stroke="currentColor"` on the path itself, the path's own attribute beat the
 * sidebar's inherited `stroke: url(#nav-brand-grad)`, so the active icon stayed dark).
 */
export function BacktestingAiIcon({ className, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 19 19"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
      focusable="false"
      {...rest}
    >
      <path d="M8.6074 1.11954C8.7334 0.62682 9.43326 0.626821 9.55926 1.11954L10.2185 3.69749C10.7522 5.78465 12.382 7.41442 14.4692 7.94816L17.0471 8.6074C17.5398 8.7334 17.5398 9.43326 17.0471 9.55926L14.4692 10.2185C12.382 10.7522 10.7522 12.382 10.2185 14.4692L9.55926 17.0471C9.43326 17.5398 8.7334 17.5398 8.6074 17.0471L7.94816 14.4692C7.41442 12.382 5.78464 10.7522 3.69748 10.2185L1.11954 9.55926C0.62682 9.43326 0.626821 8.7334 1.11954 8.6074L3.69749 7.94816C5.78465 7.41442 7.41442 5.78464 7.94816 3.69748L8.6074 1.11954Z" />
    </svg>
  );
}
